
























































import { Component, Prop, Vue } from "vue-property-decorator";
import { ILocale } from "@/@types/locale";

import draggable from "vuedraggable";
import BSwitch from "@/components/app/switchs/b-switch.vue";
import ChangeDeliteButtons from "@/components/buttons/change-delite-buttons.vue";

interface ICategory {
  _id: string;
  name: ILocale;
  show: boolean;
  sort_order: number;
  src: {
    poster: string;
    background: string;
  };
}

@Component({ components: { draggable, BSwitch, btn: ChangeDeliteButtons } })
export default class StandartCategoryList extends Vue {
  @Prop({ type: Array, default: () => [] }) categorys!: Array<ICategory>;
  @Prop({ type: Boolean, default: false }) deleted!: boolean;

  enabled = true;
  dragging = false;

  get list(): Array<ICategory> {
    return this.categorys.sort((a, b) => a.sort_order - b.sort_order);
  }

  end(): void {
    this.dragging = false;
    this.$emit("updateSortOrders", this.categorys);
  }
}
